import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {UserApplication} from '../person/user-application';
import {UserApplicationData} from '../person/user-application-data';
import { GoogleService } from './google-service';

@Service()
export class UserApplicationService {
  private readonly http = inject(HttpClient);
  private urlBase = environment.serviceUrl + 'userApplication/';
  private readonly googleService = inject(GoogleService);

  public getEmailCompanyData(application: UserApplication): Observable<UserApplicationData> {
    const url = this.urlBase + 'emailCompany';
    const body = JSON.stringify(application);
    return this.http.post<UserApplicationData>(url, body, {headers: this.getPostHeaders(), responseType: 'json'});
  }

  public getExistingApplication(credential: string): Observable<UserApplication> {
    const url = this.urlBase + 'userName/' + credential;
    return this.http.get<UserApplication>(url);
  }

  public save(application: UserApplication): Observable<string> {
    const url = this.urlBase + 'save';
    const body = JSON.stringify(application);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return new HttpHeaders({'Content-Type': 'application/json'});
  }

  getAdditionalTaskData(taskId: number): Observable<UserApplication> {
    const url = this.urlBase + 'additionalTaskData/' + taskId;
    return this.http.get<UserApplication>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
